export const INSIGHTS_PHRASES = [
  'Aggregating monthly income...',
  'Categorizing transactions...',
  'Bundling merchant name variations...',
  'Flagging outliers...',
  'Spotting round-number amounts...',
  'Scanning for weekend activity...',
  'Computing cumulative trends...',
]

export const INSIGHTS_MODULES = [
  'Income',
  'Categories',
  'Merchants',
  'Anomalies',
] as const
